// @ngInject
function LocationsApiService($q, DS, DSHttpAdapter, ResourcesService) {

    var endpoint = 'locations';

    return {
        getLocations: getLocations,
        listAll: ResourcesService.apiFactory.get(endpoint + '/brief'),
        getLocation: ResourcesService.apiFactory.get(endpoint),
        getUsers: ResourcesService.apiFactory.get(endpoint + '/users'),
        getAddressTypes: ResourcesService.apiFactory.get(endpoint + '/addresstypes'),
        getContactInfoTypes: ResourcesService.apiFactory.get(endpoint + '/contactinfotypes'),
        getUserLocations: ResourcesService.apiFactory.get(endpoint + '/user/locations'),
        updateLocation: updateLocation,
        getPricelists: ResourcesService.apiFactory.get(endpoint + '/pricelists')
    };

    function getLocations(request) 
    {
        console.log("LocationsApiService.getLocactions");
        var params = {
            filter: '',
            page: 1,
            pageSize: 20
        };

        //page, filter, pageSize, companyId, showInactiveLocations
        if (request.currentPage && request.currentPage > 1) {
            params.page = request.currentPage;
        }

        if (request.pageSize && request.pageSize > 0) {
            params.pageSize = request.pageSize;
        }

        if (!_.isEmpty(request.filter)) {
            params.filter = request.filter;
        }

        if (request.companyId) {
            params.companyId = request.companyId;
        }

        if (request.showInactiveLocations) {
            params.showInactiveLocations = request.showInactiveLocations;
        }

        if(request.matchEntireSearchTerm !== undefined) {
            params.matchEntireSearchTerm = request.matchEntireSearchTerm;
        }

        var args = { params: params };

        return ResourcesService.apiFactory.get(endpoint)(args);

    }

    function updateLocation(location) {
        var deferred = $q.defer();

        DSHttpAdapter.PUT(DS.defaults.basePath + endpoint + '/' + location.id, location).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(error);
        });

        return deferred.promise;
    }

}

angular.module('locations.api', [])
       .factory('LocationsApiService', LocationsApiService);
